import { cleanPrintingRouting } from './printing/clean-printing-routing'
import { cleanStations } from './stations/clean-stations'
import { cleanMarketing } from './marketing-references'
import { cleanPrinters } from './printing/clean-printers'
import { cleanCashDrawers } from 'shared-js/references/location-settings/cash-drawers/clean-cash-drawers'
import { cleanDeferredOrders } from 'shared-js/references/location-settings/deferred-orders/clean-deferred-orders'
import { cleanHours } from 'shared-js/references/location-settings/hours/clean-hours'
import { cleanOrderTypes } from './order-types/clean-order-types'
import { cleanTenderTypes } from 'shared-js/references/location-settings/tender-types/clean-tender-types'

export function cleanLocationSettings (settingsBlob) {
  cleanPrintingRouting(settingsBlob)
  cleanStations(settingsBlob)
  cleanMarketing(settingsBlob)
  cleanPrinters(settingsBlob)
  cleanCashDrawers(settingsBlob)
  cleanDeferredOrders(settingsBlob)
  cleanHours(settingsBlob)
  cleanOrderTypes(settingsBlob)
  cleanTenderTypes(settingsBlob)
}
